import commonConstant from '../../common/_commonConstant';

export const login = (state, action) => {
  switch (action.type) {
    case commonConstant.LOGIN_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const logout = (state, action) => {
  switch (action.type) {
    case commonConstant.LOGOUT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGOUT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const refreshToken = (state, action) => {
  switch (action.type) {
    case commonConstant.REFRESH_TOKEN_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.REFRESH_TOKEN_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
